import { useMediaQuery } from '@uidotdev/usehooks'
import { Suspense, useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import { cn } from '@/lib/utils'

import LoadingPage from './components/loading-page'
import { Sidebar } from './components/sidebar'
import { SidebarMobile } from './components/sidebar-mobile'

export default function Component() {
  const location = useLocation()
  const isMobile = useMediaQuery('only screen and (max-width : 768px)')

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
  }, [location.pathname])

  return (
    <div className={cn('relative flex', isMobile ? 'flex-col' : undefined)}>
      {/* Sidebar */}
      {!isMobile && (
        <div className="min-h-screen">
          <Sidebar />
        </div>
      )}

      <div className="min-h-screen flex-1 overflow-hidden">
        {/* Sidebar Mobile */}
        {isMobile && (
          <>
            <SidebarMobile />
            <div className="h-16" />
          </>
        )}

        {/* Content */}
        <Suspense fallback={<LoadingPage />}>
          <Outlet />
        </Suspense>
      </div>
    </div>
  )
}
